import React from 'react';

import { Typography } from '@mui/material';
import StatusIcon from 'app/shared/componentsRestyled/common/StatusIcon';

import { StatusEnum } from 'constants/status';
import { HORIZONTAL_ALIGNMENT } from 'constants/ui';

import { getDateTimeFormat } from '../../Underwriting.utils';

import { ALERTS_STYLES } from './Incomes.constants';

export const validationRulesTableConfig = {
  ruleName: {
    label: 'Report Name',
    width: '25%',
    colSpan: ({ ruleName }) => ruleName?.colSpan,
    customStyles: ({ ruleName }) => ruleName?.customStyles,
    content: ({ ruleName }) =>
      ruleName?.content ?? (
        <Typography data-truncated className="truncate" variant="regular14">
          {ruleName || '-'}
        </Typography>
      ),
    sort: true,
  },
  isValid: {
    label: 'Valid',
    width: '25%',
    content: ({ isValid }) => (
      <StatusIcon status={isValid ? StatusEnum.SUCCESS : StatusEnum.ERROR} />
    ),
    align: HORIZONTAL_ALIGNMENT.CENTER,
    sort: true,
  },
  date: {
    label: 'Date',
    width: '25%',
    content: ({ date }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {getDateTimeFormat(date)}
      </Typography>
    ),
    sort: true,
  },
  underwritingAlerts: {
    label: 'Underwriting Alerts',
    width: '25%',
    content: ({ underwritingAlerts }) =>
      underwritingAlerts.map(({ alertType, comment }) => (
        <Typography
          data-truncated
          className="truncate"
          key={`${alertType}-${comment}`}
          sx={ALERTS_STYLES[alertType.toLowerCase()]}
          variant="regular14"
        >
          {comment}
        </Typography>
      )),
    tooltip: 'Text Color: white - Informational, yellow - Warning, red - Severe',
    sort: true,
  },
};

export const qualifiedIncomesTableConfig = {
  incomeType: {
    label: 'Income Type',
    width: '20%',
    colSpan: ({ incomeType }) => incomeType?.colSpan,
    customStyles: ({ incomeType }) => incomeType?.customStyles,
    content: ({ incomeType }) =>
      incomeType?.content ?? (
        <Typography data-truncated className="truncate" variant="regular14">
          {incomeType || '-'}
        </Typography>
      ),
    sort: true,
  },
  hours: {
    label: 'Hours',
    width: '15%',
    content: ({ hours }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {hours || '-'}
      </Typography>
    ),
    sort: true,
  },
  hourRate: {
    label: 'Hour Rate',
    width: '15%',
    content: ({ hourRate }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {hourRate || '-'}
      </Typography>
    ),
    sort: true,
  },
  amount: {
    label: 'Amount',
    width: '15%',
    content: ({ amount }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {amount || '-'}
      </Typography>
    ),
    sort: true,
  },
  monthlyCalculatedAmount: {
    label: 'Monthly Calculated Amount',
    width: '20%',
    content: ({ monthlyCalculatedAmount }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {monthlyCalculatedAmount || '-'}
      </Typography>
    ),
    sort: true,
  },
  paidForDays: {
    label: 'Paid For Days',
    width: '15%',
    content: ({ paidForDays }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {paidForDays || '-'}
      </Typography>
    ),
    sort: true,
  },
};
